import { Component, LOCALE_ID, Inject} from '@angular/core';
import { AppService } from './app.service';
import { GeojsonService } from './geojson.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Sartaguda suena';
	isMap = false;
	info: Observable<any>;

  constructor(public appService: AppService,
		public geojsonService: GeojsonService,
  @Inject(LOCALE_ID) protected localeId: string ) {
		this.geojsonService.getData();
	}

  openSoinumapa() {
    window.open('http://www.soinumapa.net/ongi-etorriwelcomebienvenidoa/parte-hartuparticipateparticipar/');
  }

  openPDF(pdf:string) {
    window.open(pdf);
  }

	showMap() {
    this.appService.clear()
		this.isMap = true;
		this.appService.showMap = true;
	}

	listenStream() {
    this.appService.playRadio()
    // <audio id=\"radio\" controls autoplay preload width=100% class=\"simple-audioplayer marker-player\" src=\"http://stream.piperrak.cc/sartaguda\"></audio>
	}

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts